import React, { useState } from "react";
import { Search, Mic } from "lucide-react";
import ResponsiveSearchBarDropdown from "./ResponsiveSearchBarDropdown";


export default function SearchHero({ searchQuery, setSearchQuery, onSearch }) {

const [searchOpen, setSearchOpen] = useState(false);


  const styles = {

    section: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: "120px",
      paddingBottom: "40px"
    },

    dividerRow: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      maxWidth: "1200px",
      gap: "30px",
      marginBottom: "60px"
    },

    line: {
      flex: 1,
      height: "1px",
      background: "rgba(0,0,0,0.12)"
    },

brand: {

  fontSize: "104px",

  fontWeight: 300,

  letterSpacing: "16px",

  lineHeight: 0.9,

  textTransform: "uppercase",

  color: "#A8A8AE",

  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'SF Pro Display', sans-serif",

  textShadow:
    "0 1px 0 rgba(255,255,255,0.7)",

  transform: "translateZ(0)",

  userSelect: "none",

  opacity: 0.95,

  WebkitFontSmoothing: "antialiased",

  MozOsxFontSmoothing: "grayscale",
},





    searchBar: {

 position: "relative",
  zIndex: 61,
  isolation: "isolate",

  width: "700px",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "16px 20px",
borderRadius: searchOpen
  ? "28px 28px 0 0"
  : "28px",

transition: "all 0.22s ease",

  background: "rgba(255,255,255,0.65)",

  backdropFilter: "blur(30px) saturate(180%)",
  WebkitBackdropFilter: "blur(30px) saturate(180%)",

  border: "1px solid rgba(0,0,0,0.05)",

 boxShadow:
"0 10px 25px rgba(0,0,0,0.12), \
 0 4px 10px rgba(0,0,0,0.06), \
 inset 0 1px 0 rgba(255,255,255,0.9)"
},

    icon: {
      fontSize: "20px",
      opacity: 0.6
    },

    input: {
  flex: 1,
  border: "none",
  outline: "none",
  background: "transparent",
  fontSize: "17px",
  fontWeight: 400,
  color: "#1D1D1F",
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', Inter, system-ui"
}

  };

  return (
    <section style={styles.section}>

      <div style={styles.dividerRow}>
        <div style={styles.line}></div>

        <div style={styles.brand}>
          ELEVEN
        </div>

        <div style={styles.line}></div>
      </div>

   <div
  style={{
    position: "relative",
    zIndex: 60,
    width: "700px",
  }}
>

  <div style={styles.searchBar}>
    <Search
      size={18}
      strokeWidth={2}
      style={{ ...styles.icon, cursor: "pointer" }}
      onClick={onSearch}
    />

    <input
      style={styles.input}
      placeholder="Try Seadoo GTX 300 IBR ...."
      value={searchQuery}
      onFocus={() => setSearchOpen(true)}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") onSearch();
      }}
    />
  </div>

<ResponsiveSearchBarDropdown
    open={searchOpen}
    onClose={() => setSearchOpen(false)}
    query={searchQuery}
    onSearch={(q) => {
      setSearchQuery(q);
      onSearch(q);
    }}
  />

</div>



    </section>
  );
}